/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { LFB } from '@nexigendigital/nxui'
import { resetProduct, setCartItem, setCartOpen } from 'store/slices/shopSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function AccountSelector() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { cartItem } = useAppSelector((state) => state.shop)
    const { appSettings: { provider: { provider_name } } } = useAppSelector((state) => state.app)

    /****************************************************
     *  COMPONENT RENDER
     ****************************************************/
    return (
        <StyledContactSelector>
            <LFB
                disabled={false}
                label={`New to ${provider_name}?`}
                description={`create a new ${provider_name} account.`}
                onClick={() => dispatch(setCartItem({ ...cartItem, template: 'signup' }))}
            />
            <LFB
                disabled={false}
                label={'Existing Customer?'}
                description={`Login to your ${provider_name} account.`}
                onClick={() => {
                    dispatch(setCartOpen(false))
                    dispatch(resetProduct())
                    dispatch(setCartItem({ ...cartItem, template: 'cart' }))
                    navigate('/login')
                }}
            />
        </StyledContactSelector>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledContactSelector = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 20px 15px;

    > button {
        width: 100%;
    }
`
